import { VehicleType } from '@thive/fddm-types';
import { assertNever } from '@/helpers/utils';
import { VehiclesUtil } from '@/modules/vehicles/vehiclesUtil';
import { logger } from '@common/logging/logger';
/**
 * @description determines the suitable vehicles to support in a shape as a default
 */
export const findDefaultSupportVehiclesForArea = (
  enabledVehicles: VehicleType[],
  subGroup: 'shuttles' | 'forklifts',
  amount: 'includeAll' | 'limitToOne',
): VehicleType[] => {
  if (enabledVehicles.length === 0) {
    // TODO: FDDM: track exception
    logger.error(
      'Expected at least 1 enabled vehicle in order to determine the default one. But got: ',
      enabledVehicles,
    );
    return [];
  }

  let vehiclesInSubGroup: VehicleType[] = [];

  switch (subGroup) {
    case 'forklifts':
      vehiclesInSubGroup = enabledVehicles.filter(
        (item) => !VehiclesUtil.isShuttleVehicle(item.id),
      );
      break;
    case 'shuttles':
      vehiclesInSubGroup = enabledVehicles.filter((item) => VehiclesUtil.isShuttleVehicle(item.id));
      break;
    default:
      assertNever(subGroup);
  }

  switch (amount) {
    case 'limitToOne':
      return [vehiclesInSubGroup[0]];
    case 'includeAll':
      return vehiclesInSubGroup;
    default:
      assertNever(amount);
  }
};
